import { create } from 'zustand';

/**
 * The picture behind everything, following the cursor.
 *
 * Seerr does this and it is most of why that screen feels alive: the
 * background is whatever you are looking at, not a fixed colour. It costs
 * nothing to browse — the images are already being fetched for the posters —
 * and it turns a grid of tiles into a room that changes as you walk through
 * it.
 *
 * DRIVEN FROM THE DOM, not from props. Any element can declare a backdrop by
 * carrying `data-backdrop`, and a single listener picks it up when that
 * element takes focus. The alternative — an onFocus prop threaded through
 * Poster, ResultCard, the recents strip and whatever comes next — is the
 * parallel registry this codebase has already been bitten by twice: it only
 * ever contains what somebody remembered to wire up.
 */
interface BackdropState {
  /** What to show. Null means the plain background. */
  url: string | null;
  /**
   * The detail screen draws its own hero from the same image, at a treatment
   * built for it. Two of them at once is muddy rather than twice as good.
   */
  suppressed: boolean;
  set(url: string | null): void;
  suppress(on: boolean): void;
}

export const useBackdrop = create<BackdropState>((set) => ({
  url: null,
  suppressed: false,
  set: (url) => set((s) => (s.url === url ? s : { url })),
  suppress: (suppressed) => set({ suppressed }),
}));
